import { useState } from 'react';
import { getChatMessages, getUserChatMessages } from '../api/chatApi';
import { MessageReceivePayload } from '../datatypes';
import { Chat } from './useChats';


interface UseUserChatMessagesResult {
    loading: boolean;
    error: string | null;
    fetchMessages: (userId: string) => Promise<{ chat: Chat, messages: MessageReceivePayload[] } | undefined>
}

export function useUserChatMessages(): UseUserChatMessagesResult {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const fetchMessages = async (userId: string): Promise<{ chat: Chat, messages: MessageReceivePayload[] } | undefined> => {
        setLoading(true);
        setError(null);
        try {
            const res = await getUserChatMessages(userId);
            const data: { chat: Chat, messages: MessageReceivePayload[] } = res.data
            data.messages = data.messages.map(msg => ({ ...msg }));
            return data;
        } catch (e: any) {
            setError('Failed to fetch messages: ' + (e?.message || e));
        } finally {
            setLoading(false);
        }
    };

    return { loading, error, fetchMessages };
} 